import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { MiniHeader } from "../components/MiniHeader";
import { FilmCard } from "../components/Showcase";
import { SubmitFilm } from "../components/SubmitFilm";
import { Chuckle, OnInk, Bob } from "../components/Characters";
import { api, thumbUrl } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Account() {
  const { user } = useAuth();
  const [films, setFilms] = useState(null);

  const load = useCallback(() => {
    api.get("/films/mine")
      .then((r) => setFilms(Array.isArray(r.data?.items) ? r.data.items : []))
      .catch(() => setFilms([]));
  }, []);

  useEffect(() => {
    if (user) load();
  }, [user, load]);

  if (user === false) return <Navigate to="/login" replace />;
  if (!user || films === null) return <div className="min-h-screen bg-paper"><MiniHeader /></div>;

  const used = films.map((f) => f.category);
  return (
    <div className="min-h-screen bg-paper text-ink">
      <MiniHeader />
      <main data-testid="account-page" className="mx-auto max-w-6xl px-5 py-12 sm:px-8 lg:py-16">
        <p className="font-body text-base font-semibold text-ink/80">Signed in as {user.email}</p>
        <h1 className="mt-2 font-head text-5xl leading-none tracking-tight sm:text-6xl">Your entries <span className="text-ink/60" data-testid="entries-count">{films.length}/2</span></h1>
        {films.length > 0 && (
          <div className="mt-10 grid gap-6 sm:grid-cols-2" data-testid="my-films">
            {films.map((f, i) => (
              <FilmCard key={f.id} testId={`my-film-${i}`} film={{ title: f.title, creator: f.creator_name, category: f.category, thumbnail: thumbUrl(f.id), url: f.watch_url }} />
            ))}
          </div>
        )}
        <div className="mt-12 max-w-3xl">
          {films.length < 2 ? (
            <SubmitFilm key={films.length} used={used} defaultCreator={user.name} onDone={load} />
          ) : (
            <div data-testid="entries-full" className="flex flex-col items-start gap-5 rounded-[36px] bg-sun p-8 sm:flex-row sm:items-center">
              <OnInk className="h-24 w-24 shrink-0"><Bob className="w-[66%]"><Chuckle className="h-auto w-full" /></Bob></OnInk>
              <p className="font-head text-2xl sm:text-3xl">Both films are in. We'll email you when the shortlist is ready.</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
